import {ADMIN} from '../config'
import axios from "axios";

export const adminApi = axios.create({
    baseURL: ADMIN,
    timeout: 5000,
});


export async function getUserList(username){
    try {
        const res = await adminApi.get(`/polistar/user/list`, { params: { name: username } })
        if(res.data.resultcode === '200'){
            return res.data.data;
        } else {
            return []
        }
    } catch (err) {
        return null;
    }
}

export async function upLoadImg(formData){

    try {
        const res = await adminApi.post(`/polistar/upload/image`, formData)
        if(res.data.resultcode === '200'){
            return res.data.data;
        } else {
            return []
        }
    } catch (err) {
        return null;
    }
}

export async function registerNews(userid, title,content,image){
    try {
        const params = {
            userid: userid,
            title: title,
            content:content,
            image:image
        }
        const res = await adminApi.post(`polistar/notice`, params)
        if(res.data.resultcode === '200'){
            return res.data.data;
        } else {
            return []
        }
    } catch (err) {
        return null;
    }
}
